/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetMerchantAdminUsersResponse } from '../../models/get-merchant-admin-users-response';

export interface ListMerchantUsers$Params {
}

export function listMerchantUsers(http: HttpClient, rootUrl: string, params?: ListMerchantUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMerchantAdminUsersResponse>> {
  const rb = new RequestBuilder(rootUrl, listMerchantUsers.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMerchantAdminUsersResponse>;
    })
  );
}

listMerchantUsers.PATH = '/users/merchant-admin-users';
